export const FOCUSABLE_ELS = `
  [contenteditable]:not([contenteditable='false']),
  [tabindex]:not([tabindex='-1']),
  a[href]:not([disabled]),
  button:not([disabled]),
  details:not([disabled]),
  embed:not([disabled]),
  iframe:not([disabled]),
  input[type='checkbox']:not([disabled]),
  input[type='radio']:not([disabled]),
  input[type='text']:not([disabled]),
  object:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled])
`;
